/* eslint-disable max-len */
import { useEffect, useState } from "react";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { muiColors } from "themes/colors";
import { useTranslate } from "react-admin";
import { CustomButton } from "./CustomButton";

interface AdvancedDetailsProps {
  children?: JSX.Element;
  open?: boolean;
  marginTop?: number | string;
}

const AdvancedDetails = ({
  children,
  open,
  marginTop
}: AdvancedDetailsProps) => {
  const translate = useTranslate();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  useEffect(() => {
    if (open) {
      setIsOpen(true);
    }
  }, [open]);
  return (
    <div className="mt-6 mb-2 w-full" style={{ marginTop: marginTop ?? 24 }}>
      <CustomButton
        variant="tertiary"
        text={translate("users.advanced_details")}
        onClick={() => setIsOpen((prev) => !prev)}
        startIcon={
          <AddOutlinedIcon
            style={{
              transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
              transition: "all 150ms ease-in-out"
            }}
          />
        }
        sx={{
          padding: "0px 16px",
          fontSize: "15px",
          backgroundColor: open ? muiColors.error : undefined,
          color: open ? "#fff" : muiColors.text.primary,
          svg: {
            fill: open ? "#fff" : muiColors.text.primary
          },
          "&:hover": {
            backgroundColor: open ? muiColors.error : undefined
          }
        }}
      />
      {isOpen && (
        <div className="border-t border-[rgba(48,47,46,0.15)] mt-2 pt-6">
          {children}
        </div>
      )}
    </div>
  );
};

export default AdvancedDetails;
